import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export default function CustomNavigation() {
  const location = useLocation();
  const navigate = useNavigate();
  const manuallyNavigating = useRef(false);

  const [stack, setStack] = useState(() => {
    const stored = sessionStorage.getItem("navigationStack");
    return stored ? JSON.parse(stored) : [location];
  });

  const [currentIndex, setCurrentIndex] = useState(() => {
    const stored = sessionStorage.getItem("navigationStackIdx");
    return stored ? Number(stored) : 0;
  });

  const stackRef = useRef(stack);
  const indexRef = useRef(currentIndex);

  useEffect(() => {
    stackRef.current = stack;
    indexRef.current = currentIndex;
    sessionStorage.setItem("navigationStack", JSON.stringify(stack));
    sessionStorage.setItem("navigationStackIdx", currentIndex.toString());
  }, [stack, currentIndex]);

  const prevLocation = useRef(location);

  useEffect(() => {
    if (manuallyNavigating.current) {
      manuallyNavigating.current = false;
      prevLocation.current = location;
      return;
    }

    const prev = prevLocation.current;
    prevLocation.current = location;

    if (prev.pathname === location.pathname && prev.search === location.search) {
      return;
    }

    const s = stackRef.current;
    const idx = indexRef.current;
    const foundIndex = s.findIndex(
      (entry) => entry.pathname === location.pathname && entry.search === location.search
    );

    if (foundIndex !== -1 && foundIndex < idx) {
      // Going back
      let lastDifferentIndex = idx - 1;
      while (lastDifferentIndex >= 0 && s[lastDifferentIndex].pathname === s[idx].pathname) {
        lastDifferentIndex--;
      }

      if (lastDifferentIndex >= 0 && s[lastDifferentIndex].pathname !== location.pathname) {
        const offset = lastDifferentIndex - idx + 1;
        manuallyNavigating.current = true;
        setCurrentIndex(lastDifferentIndex);
        setTimeout(() => {
          navigate(offset);
        }, 0);
      } else {
        setCurrentIndex(idx - 1);
      }
    } else {
      // Push new entry
      const newStack = s.slice(0, idx + 1);
      newStack.push({ pathname: location.pathname, search: location.search, key: location.key });
      setStack(newStack);
      setCurrentIndex(newStack.length - 1);
    }
  }, [location, navigate]);

  return null;
}
